import { DocumentCivilStatusMarriageUploadCrumbs } from 'civil-status/constants/breadcrumb';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import FormDocumentMarriageUploadNew from 'civil-status/components/upload-document-marriage-form';
import { DocumentMarriageUploadFormVM } from 'civil-status/view-models/document-birth-form';
import { transformUploadMarriageNewPage } from 'civil-status/utils/transform-upload-new-act';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';

export default function DocumentMarriageUploadNewPage(): React.ReactElement {
  const insert = useHttpClient(
    `${__CIVIL_STATUS_API_URL__}/atti-matrimonio-sima/caricamento-atto-matrimonio/inesistente`,
    {
      options: { method: 'POST', loading: true, errorCatching: true },
    }
  );

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: DocumentMarriageUploadFormVM | undefined) => {
      const data = transformUploadMarriageNewPage(formValues);
      (
        insert({
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/matrimonio');
      });
    },
    [insert, navigate]
  );

  return (
    <>
      <Breadcrumbs items={DocumentCivilStatusMarriageUploadCrumbs} base="stato-civile" />
      <FormDocumentMarriageUploadNew
        title="Caricamento Nuovo Atto"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/stato-civile/matrimonio');
        }}
      />
    </>
  );
}

DocumentMarriageUploadNewPage.displayName = 'home page component';
